<app-list-subheader-empty></app-list-subheader-empty>
<ng-container>

  <app-kanban-view-empty />

</ng-container>
